/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IAdmission } from 'app/shared/model/admission.model';
import { INurse } from 'app/shared/model/nurse.model';
import { IPrescription } from 'app/shared/model/prescription.model';
import { PatientType } from 'app/shared/model/enumerations/patient-type.model';

export interface IImplantOrder {
  id?: string;
  active?: boolean;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  cursor?: number;
  patientType?: keyof typeof PatientType | null;
  admission?: IAdmission | null;
  orderedBy?: INurse | null;
  prescription?: IPrescription | null;
}

export const defaultValue: Readonly<IImplantOrder> = {
  active: false,
};
